import { useEffect } from 'react';

type UseResizeCarouselImageOptions = {
  media?: unknown;
  minWidth?: number;
  minHeight?: number;
  containerSelector?: string;
  imageSelector?: string;
};

export const useResizeCarouselImage = ({
  media,
  minWidth = 300,
  minHeight = 300,
  containerSelector = '.media-container',
  imageSelector = '.carousel-image',
}: UseResizeCarouselImageOptions) => {
  useEffect(() => {
    if (!media) return;

    const container = document.querySelector(containerSelector);
    if (!container) return;

    const images = container.querySelectorAll<HTMLImageElement>(imageSelector);

    const sizeImageOnce = (img: HTMLImageElement) => {
      const wrapper = img.parentElement as HTMLElement | null;
      if (!wrapper) return;

      const { naturalWidth: imageWidth, naturalHeight: imageHeight } = img;
      if (!imageWidth || !imageHeight) return;

      if (imageWidth >= minWidth || imageHeight >= minHeight) {
        img.classList.remove('resize-image-65');
        img.classList.add('resize-image-100');
      } else {
        img.classList.remove('resize-image-100');
        img.classList.add('resize-image-65');
      }
      img.classList.add('is-visible');
    };

    images.forEach(img => {
      if (img.complete) {
        sizeImageOnce(img);
      } else {
        img.addEventListener('load', () => sizeImageOnce(img), {
          once: true,
        });
      }
    });
  }, [media, minWidth, minHeight, containerSelector, imageSelector]);
};
